import { Controller } from '@hotwired/stimulus'

// Provider assignments controller for health goal edit page
// Usage: data-controller="admin--provider-assignments"
export default class extends Controller {
  static values = {
    healthGoalId: String,
    reorderUrl: String
  }

  static targets = ['categoryContainer']

  connect() {
    // Setup is done via targets
  }

  // Handle category sorting within each category section
  setupCategorySorting(container, categoryLabel) {
    const items = container.querySelectorAll('[data-provider-item]')

    items.forEach((item) => {
      item.setAttribute('draggable', 'true')
      item.addEventListener('dragstart', (e) => this.handleDragStart(e, categoryLabel))
      item.addEventListener('dragend', (e) => this.handleDragEnd(e))
      item.addEventListener('dragover', (e) => this.handleDragOver(e))
      item.addEventListener('dragenter', (e) => this.handleDragEnter(e))
      item.addEventListener('dragleave', (e) => this.handleDragLeave(e))
      item.addEventListener('drop', (e) => this.handleDrop(e, categoryLabel))
    })
  }

  handleDragStart(event, categoryLabel) {
    this.draggedItem = event.currentTarget
    this.currentCategory = categoryLabel
    event.currentTarget.classList.add('opacity-50', 'bg-slate-100')
    event.dataTransfer.effectAllowed = 'move'
  }

  handleDragEnd(event) {
    event.currentTarget.classList.remove('opacity-50', 'bg-slate-100')
    document.querySelectorAll('[data-provider-item]').forEach((item) => {
      item.classList.remove('border-t-2', 'border-blue-500')
    })
    this.draggedItem = null
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }

  handleDragEnter(event) {
    event.preventDefault()
    const target = event.currentTarget
    if (target !== this.draggedItem && target.dataset.category === this.currentCategory) {
      target.classList.add('border-t-2', 'border-blue-500')
    }
  }

  handleDragLeave(event) {
    event.currentTarget.classList.remove('border-t-2', 'border-blue-500')
  }

  handleDrop(event, categoryLabel) {
    event.preventDefault()
    const target = event.currentTarget
    target.classList.remove('border-t-2', 'border-blue-500')

    // Only allow drops within the same category
    if (target.dataset.category !== this.currentCategory) {
      return
    }

    if (this.draggedItem && target !== this.draggedItem) {
      const container = target.closest('[data-category-container]')
      const items = Array.from(container.querySelectorAll('[data-provider-item]'))
      const draggedIndex = items.indexOf(this.draggedItem)
      const targetIndex = items.indexOf(target)

      if (draggedIndex < targetIndex) {
        target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
      } else {
        target.parentNode.insertBefore(this.draggedItem, target)
      }

      this.saveOrder(categoryLabel, container)
    }
  }

  async saveOrder(categoryLabel, container) {
    const providerIds = Array.from(container.querySelectorAll('[data-provider-item]'))
      .map((item) => item.dataset.providerId)

    try {
      const response = await fetch(this.reorderUrlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          category_label: categoryLabel,
          provider_ids: providerIds
        })
      })

      if (!response.ok) {
        console.error('Failed to save order')
      }
    } catch (error) {
      console.error('Error saving order:', error)
    }
  }

  // Auto-submit forms on change
  submitOnChange(event) {
    const form = event.currentTarget.closest('form')
    if (form) {
      form.requestSubmit()
    }
  }
}
